import React, { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext(null);

export const CompareProvider = ({ children }) => {
    const [comparingList, setComparingList] = useState([]); // array of propiedad objects, max 3

    const addToCompare = useCallback((propiedad) => {
        setComparingList(prev => {
            if (prev.find(p => p.id === propiedad.id)) return prev; // already added
            if (prev.length >= 3) return prev; // max 3
            return [...prev, propiedad];
        });
    }, []);

    const removeFromCompare = useCallback((id) => {
        setComparingList(prev => prev.filter(p => p.id !== id));
    }, []);

    const clearCompare = useCallback(() => setComparingList([]), []);

    const isComparing = useCallback((id) => comparingList.some(p => p.id === id), [comparingList]);

    return (
        <CompareContext.Provider value={{ comparingList, addToCompare, removeFromCompare, clearCompare, isComparing }}>
            {children}
        </CompareContext.Provider>
    );
};

export const useCompare = () => {
    const ctx = useContext(CompareContext);
    if (!ctx) throw new Error('useCompare must be used inside CompareProvider');
    return ctx;
};
